export const DAY_KINDS = {
  WORK: 1,
  OFF_WORK: 2,
  HOLIDAY: 3,
  COMPANY_HOLIDAY: 4,
  ABSENCE: 7,
  HOLIDAY_HALF: 8,
  COMPANY_HOLIDAY_HALF: 11,
};
